import PageSendWaterToWaterMachine from "./PageSendWaterToWaterMachine";

export default PageSendWaterToWaterMachine;
